export default "__VITE_ASSET__CcUgSNcu__"